import styled from 'styled-components';
import { variables } from 'components/theme';
import { itemTitleColor } from 'utils/theme';

export const ContactInfo = styled.div`
  width: 100%;
  margin: 112px 0px 35px;
  border-bottom: 2px solid rgb(246, 246, 246);

  input {
    width: 100%;
    border-radius: 8px;
    box-shadow: none;
    padding: 14px;
    height: 42px;
    align-items: center;
    transition: all 0.1s ease-in-out;

    &:focus {
      border-color: ${variables.colors.grey7};
      box-shadow: none;
    }
  }
  h4 {
    color: ${itemTitleColor};
    line-height: 0;
    padding-bottom: 28px;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 42px;
  }
`;

export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;

  @media only screen and (max-width: 1024px) {
    display: block;
    margin: 0 auto;
  }
`;

export const InputColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 80%;
  flex: 1;

  &:first-child {
    margin-right: 14px;
  }

  @media only screen and (max-width: 1024px) {
    display: block;
    width: 100%;

    &:first-child {
      margin-right: 0px;
    }
  }
`;
